<template>
  <v-dialog :value="value" @input="$emit('input', $event)" width="600" persistent v-on:keydown.esc="$emit('closeDialog')" overlay-color="#d1d2d3" overlay-opacity="0.55">
    <template>
      <div class="dialog-header-container d-flex align-center">
        <div class="dialog-header-text">{{$t('menuLayout.share')}}</div>
        <div class="dialog-header-btn" @click="$emit('closeDialog')">
          <v-icon class="pl-1" size="24" color="white">md mdi-close</v-icon>
        </div>
      </div>
      <v-card class="dialog-card">
        <div class="px-4 pt-2 share-dialog-content-container">
          <div class="share-dialog-copy d-flex align-center justify-center" @click="copyContent(pathText)">
            <div class="share-dialog-text-container">
              {{$t('menuLayout.dialog.copyPath')}}
              <v-icon class="pl-1" size="20">md mdi-content-copy</v-icon>
            </div>
          </div>
          <input v-model="pathText" readonly  class="share-dialog-input"/>
        </div>

        <div class="px-4 pt-2share-dialog-content-container">
          <div class="share-dialog-copy d-flex align-center justify-center" @click="copyContent(pathUrl)">
            <div class="share-dialog-text-container">
              {{$t('menuLayout.dialog.copyLink')}}
              <v-icon class="pl-1"  size="20">md mdi-content-copy</v-icon>
            </div>
          </div>
          <input v-model="pathUrl" readonly  class="share-dialog-input"/>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="var(--accentColor)"
            @click="$emit('closeDialog')"
            class="white--text dialog-button"
          >
            {{$t('menuLayout.dialog.ready')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>
<script>
export default {
  props: ['value', 'pathText', 'pathUrl'],
  methods: {
    copyContent(content) {
      navigator.clipboard.writeText(content)
    }
  }
}
</script>
<style>
  .share-dialog-copy {
    width: 100%;
    height: 35px;
    background-color: #f5f5f5;
    cursor: pointer;
    height: 35px;
    border: 1px solid #c6c6c6;
    border-radius: 2px 0 0 2px;

  }
  .share-dialog-text-container {
    user-select: none;
    font-size: 14px;
  }
  .share-dialog-content-container {
    padding-top: 10px;
    display: flex;
    max-width: 100%;
    height: 100px;
    flex-direction: column;
  }
  .share-dialog-input {
    width: 100%;
    display: flex;
    word-break: break-all;
    white-space: pre-wrap;
    flex: 1;
    max-width: 100%;
    border: 1px solid #dcdcdc;
    -webkit-border-radius: 0 0 2px 2px;
    border-radius: 4px;
    border-top: none;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 8px 4px;
    max-height: 35px;
    font-size: 13.3333px;
  }
  .share-dialog-input:focus, .share-dialog-input:active {
    outline: none !important;
  }
  .v-dialog {
    border-radius: 10px;
  }
  .dialog-button {
    height: var(--dialog-button-height) !important;
    padding: 0px 16px !important;
    min-width: 80px !important;
    box-sizing: unset;
    transition-property: background;
    transition-duration: 0.7s;
  }
  .dialog-button .v-btn__content {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: normal;
  }
  .dialog-button:hover {
    background: rgba(var(--accentColorValue), 0.2) !important;
    color: var(--accentColor) !important;
  }
</style>